import { Component, ChangeDetectionStrategy, Input, OnInit } from '@angular/core';

import { ArticleModel } from '@modules/article/models/article.model';
import { ActionIcons, ButtonItem } from '@modules/ui/action-container/action-container.component';

import { LocalizedDatePipe } from '../../pipes/localized-date.pipe';
import { MetaItemsComponent } from '../../ui/meta-items/meta-items.component';

@Component({
  selector: 'mb-article-card',
  templateUrl: './article-card.component.html',
  styleUrls: ['./article-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MetaItemsComponent, LocalizedDatePipe],
})
export class ArticleCardComponent implements OnInit {
  public showMetaItems = false;

  @Input() article!: ArticleModel;
  @Input() actions: ButtonItem[] = [
    {
      icon: ActionIcons.SHARE,
      class: 'btn btn-quaternary',
    },
    {
      icon: ActionIcons.BOOKMARK,
      class: 'btn btn-quaternary',
    },
    {
      icon: ActionIcons.DOWNLOAD,
      class: 'btn btn-quaternary',
    },
  ];

  ngOnInit(): void {
    this.showMetaItems = this.article.metaItems.some((metaItem) => metaItem.count);
  }
}
